import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { uniqBy } from 'lodash';

import { ScheduleBlock, ScheduleBlockItem } from '@/tools/models/class-builder.models';
import EdInputModel from '@/models/ed-input.model';

@Component({
  components: {
    EdBlockItemGroup: () => import(/* "EdBlockItemGroup" */ '../ed-block-item-group/ed-block-item-group.component.vue'),
    EdBlockItemAdd: () => import(/* "EdBlockItemAdd" */ '../ed-block-item-add/ed-block-item-add.component.vue'),
  }
})
export default class EdCreateBlocksModalComponent extends Vue {
  @Prop({}) readonly params: any;

  isEditingBlockGroup = false;
  title = EdInputModel('title',  '');
  description = EdInputModel('description',  '');
  isCreationTimeFormShown = false;
  blocksItems: ScheduleBlockItem[] = [];
  blocksToAdd: ScheduleBlockItem[] = [];

  @Ref('blockItemGroup') readonly blockItemGroup: any; 

  get isWeeklySchedule(): boolean {
    return this.params.isWeeklySchedule;
  }

  get scheduleBlockToEdit(): ScheduleBlock {
    return this.params.scheduleBlockToEdit;
  }

  get blocksCreated(): ScheduleBlock[] {
    return this.params.blocksCreated;
  }

  get workingDays(): string[] {
    return this.params.workingDays;
  }

  get isAbleToModify(): boolean {
    return this.params.isAbleToModify;
  }

  get scheduleBlocksCreated(): ScheduleBlock {
    return this.params.scheduleBlocksCreated;
  }

  get scheduleBlockInEdition(): ScheduleBlock {
    return this.params.scheduleBlockInEdition;
  }

  get weekdays(): number[] {
    return this.params.weekdays;
  }

  get scheduleStartHour(): string {
    return this.params.scheduleStartHour;
  }

  get scheduleEndHour(): string {
    return this.params.scheduleEndHour;
  }

  get isFormValid() {
    const blockItemsFiltered = this.blocksItems.filter(b => !b.toDelete);

    return this.title.value && blockItemsFiltered.length > 0;
  }

  emitOnCreateBlocks(): void {
    this.close();
    this.params.onCreateBlocks({
      id: this.scheduleBlockToEdit?.id || null,
      title: this.title.value,
      description: this.description.value,
      scheduleEntries: this.blocksItems,
    })
  }

  open() {
    const block = this.scheduleBlockToEdit;

    this.resetForm();

    this.title.value = block?.title || '';
    this.description.value = block?.description || '';
    this.blocksItems = block?.scheduleEntries || [];
    this.isCreationTimeFormShown = this.blocksItems.length === 0;
  }

  close() {
    this.blockItemGroup.hideEditionMode();
    this.isCreationTimeFormShown = false;
    this.$EdModal.closeModal();
  }

  onAddBlock({ add }) {
    if (this.scheduleBlockToEdit?.id) {
      this.blocksToAdd = add;
    }

    this.blocksItems = [...this.blocksItems, ...add];
  }

  cancelAddBlock() {
    if(this.blocksItems?.length > 0)
      this.isCreationTimeFormShown = false;
  }


  onEditingBlocks() {
    this.isCreationTimeFormShown = false;
  }

  onUpdateBlocks(blocks: ScheduleBlockItem[]) {
    const blocksToAddFiltered = this.blocksToAdd.filter(
      b => blocks.some(bi => bi.day === b.day && bi.start === b.start && bi.end === b.end && !bi.toDelete)
    );
 
    // Set blocksItems ensuring that each element is unique
    this.blocksItems = uniqBy([ ...blocks, ...blocksToAddFiltered, ], b => `${b.day}-${b.start}-${b.end}-${b.toDelete}`);    
  }

  openCreationTimeForm() {
    this.isCreationTimeFormShown = true;
    this.blockItemGroup.hideEditionMode();
  }

  resetForm() {
    this.title.value = '';
    this.blocksItems = [];
  }

  mounted() {
    this.open();
  }
}